import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotificationService } from '../../../core/services/notification.service';
import { AppNotification } from '../../../core/models/notification.model';
import { FORM_ID, formID } from '../../../helpers/form-id.enum';

@Component({
  selector: 'ec-notification-panel',
  imports: [CommonModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss',
})
export class NotificationPanelComponent implements OnInit {
  protected readonly svc = inject(NotificationService);
  readonly close = output<void>();
  formID = formID;

  ngOnInit(): void {
    this.svc.loadData(this.formID.NOTIFICATIONS_LIST);
  }

  get notifications(): readonly AppNotification[] {
    return this.svc.notifications();
  }

  get unreadCount(): number {
    return this.svc.unreadCount();
  }

  markRead(n: AppNotification): void {
    this.svc.markRead(n.id);
  }

  toggleRead(n: AppNotification, event?: Event): void {
    if (event) event.stopPropagation();
    this.svc.toggleRead(n.id);
  }

  markAllRead(): void {
    this.svc.markAllRead();
  }

  dismiss(n: AppNotification, event?: Event): void {
    if (event) event.stopPropagation();
    this.svc.dismiss(n.id);
  }

  timeAgo(date: Date): string {
    const s = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    if (s < 60) return 'just now';
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
  }

  getPriorityClass(priority?: string): string {
    const map: Record<string, string> = {
      High: 'text-red-500 font-medium',
      Medium: 'text-amber-500 font-medium',
      Low: 'text-emerald-500 font-medium',
    };
    return (priority && map[priority]) || 'text-amber-500 font-medium';
  }

  getIconClass(icon?: string): string {
    const map: Record<string, string> = {
      checklist: 'bi bi-clipboard-check text-amber-500',
      'shield-alert': 'bi bi-exclamation-triangle text-amber-500',
      warning: 'bi bi-exclamation-triangle text-amber-500',
      risk: 'bi bi-shield-exclamation text-amber-500',
      compliance: 'bi bi-shield-check text-amber-500',
      sync: 'bi bi-arrow-repeat text-amber-500',
      badge: 'bi bi-patch-check text-amber-500',
      info: 'bi bi-info-circle text-amber-500',
    };
    return (icon && map[icon]) || 'bi bi-clipboard-check text-amber-500';
  }

  navigate(n: AppNotification): void {
    this.svc.markRead(n.id);
    this.close.emit();
  }
}

